import React, { Component } from "react";
import { connect } from "react-redux";
import { DeviceGroupInfoDialog } from "../dialogs/DeviceGroupInfoDialog";
import { mapKV, asSimpleArray } from "../utils/map";
import { vrTypesToString } from "../utils/appUtils";

export class DeviceGroupInfo extends Component {
  render() {
    const {
      deviceGroup,
      onClose,
      onEdit,
      onDelete,
      contentBundles,
      apps
    } = this.props;

    if (!deviceGroup) return (<div />);

    let allAppBundles = [];
    mapKV(contentBundles, (key, { name }) =>
      allAppBundles.push({ value: key, label: name })
    );

    let selectedBundleKeys = [];
    deviceGroup.contentBundleRefs.map(s => selectedBundleKeys.push(s.id));

    const { kioskAppRef, firstTimeUseAppRef } = deviceGroup;
    const kioskAppTitle = (kioskAppRef && apps[kioskAppRef.id]) ? apps[kioskAppRef.id].title : "None";
    const firstTimeUseAppTitle = (firstTimeUseAppRef && apps[firstTimeUseAppRef.id]) ? apps[firstTimeUseAppRef.id].title : "None";

    return (
      <DeviceGroupInfoDialog
        deviceGroup={deviceGroup}
        apps={apps}
        onClose={onClose}
        onEdit={onEdit}
        allAppBundles={allAppBundles}
        selectedBundleKeys={selectedBundleKeys}
        onDelete={onDelete}
        kioskAppTitle={kioskAppTitle}
        firstTimeUseAppTitle={firstTimeUseAppTitle}
      />
    );
  }
}

const mapStateToProps = state => ({
  contentBundles: state.data.contentBundles,
  apps: state.data.apps
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceGroupInfo);
